import api from "../service";
import { store } from "store/configureStore";
import { hotToast } from "utils";
import { format } from "date-fns";
import SumryTypes from "Mapa/types/SumaryTypes";
import FilterValues from "Mapa/types/FilterValues";

export const getIncidencias = async () => {
  await api.setToken();

  const result = format(new Date(), "yyyy-MM-dd");

  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/incident?date_init=${result}&date_end=${result}`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};

export const getEjecuciones = async (query: string) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/execution${query}`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};
export const getDegustaciones = async (query: string) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/tasting${query}`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};

export const cmbCategoria = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/categories`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};

export const cmbMarcas = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/brands`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};

export const cmbSucursal = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/stores-filter/stores`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};
export const cmbCiudad = async (estado: number) => {
  if (estado <= 0) {
    return hotToast("No hay un estado", "ERROR");
  }
  await api.setToken();

  const endPoint = `project/cityclub/stores-filter/cities/${estado}`;
  const isValid: object | any | null = await api.requestGet(endPoint);
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};
export const cmbEstado = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/stores-filter/states`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};
export const cmbUsuario = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `project/cityclub/stores-filter/users`
  );
  const { data, ok } = isValid;
  if (ok) {
    return data;
  }
  return null;
};

export const cmbProfiles = async () => {
  await api.setToken();
  const responseApi: object | any | null = await api.requestGet(
    `project/cityclub/stores-filter/profiles`
  );
  const { data, ok } = responseApi;
  if (ok) {
    return data;
  }
  return null;
};

export const getStoresActive = async (filterValues: FilterValues) => {
  const keys = {
    estado: "id_state",
    ciudad: "id_city",
    usuarios: "id_user",
    perfiles: "id_profile",
    sucursales: "id_sucursal",
  };
  const queryFilters = Object.entries(filterValues)
    .filter(([key, value]) => value && value.id)
    .map(([key, value]) => {
      //@ts-ignore
      return `${keys[key]}=${value.id}`;
    });
  const endPoint = `project/cityclub/stores?${queryFilters.join("&")}`;
  const responseApi = await api.requestGet(endPoint);
  if (responseApi.ok) {
    // const results = responseApi.data.filter((item: any) => {
    //   const { supervisor, demonstrators } = item;
    //   const total = supervisor || 0 + demonstrators || 0;      
    //   if (total > 0) return item;
    // });
    return responseApi.data;
  }
  
  return [];
};

export const getStoreDetail = async (storeId: number) => {
  const endPoint: string = `project/cityclub/stores/${storeId}/detail`;
  const responseApi = await api.requestGet(endPoint);
  if (responseApi.ok) return responseApi.data;
  return {};
};

export const getSumary = async () => {
  const endPoint = "project/cityclub/stores/summary";
  const responseApi = await api.requestGet(endPoint);
  if (responseApi.ok) return responseApi.data[0] as SumryTypes;
  return {
    supervisor: 0,
    demonstrators: 0,
  } as SumryTypes;
};
